const specialtiesAvailableMessage = 'Choose a specialty from the list below';
const noSpecialtiesAvailableMessage = 'Specialty not found, enter another';

const finish = (input, value) => {
    input.value = value;
    input.style.removeProperty('font-size');
};

export const showSearchInputRequiredMessage = (input, isSpecialtiesAvailable) => {
    const prevValue = input.value;
    const isPrevValueIsMessage = prevValue === specialtiesAvailableMessage ||
        prevValue === noSpecialtiesAvailableMessage;
    if (!isPrevValueIsMessage) {
        input.value = isSpecialtiesAvailable ? specialtiesAvailableMessage : noSpecialtiesAvailableMessage;
        if (window.innerWidth < 1440) {
            input.style.fontSize = '14px';
        } else {
            input.style.fontSize = '16px';
        }

        let focusEventFired = false;
        const inputFocusHandler = () => {
            focusEventFired = true;
            finish(input, prevValue);
            input.removeEventListener('focus', inputFocusHandler)
        };
        input.addEventListener('focus', inputFocusHandler);
        setTimeout(() => {
            if (!focusEventFired) {
                finish(input, prevValue);
            }
        }, 3000);
    }
}



// WEBPACK FOOTER //
// ./src/client/utils/show-search-input-required-message.js